import * as THREE from "three";
import type { Player } from "../player/Player";

const SQUASH_DECAY_LAMBDA = 14;
const BREATH_LAMBDA = 8;
const BREATH_GAIN = 0.06;

// Per-frame visual scale modulation on the player mesh. Two layers:
//   1) Transient squash on rotate: pinch on Y, stretch on X (or vice versa
//      depending on direction), decays to identity in ~180ms.
//   2) Continuous "breath" pulse from the audio low band so the ball
//      pumps to the kick.
// Visual-only; the Cannon Sphere body is unaffected.
export class PlayerPulse {
  private player: Player;
  private squashX = 0;
  private squashY = 0;
  private breath = 0;

  constructor(player: Player) {
    this.player = player;
  }

  onRotate(direction: 1 | -1): void {
    // Lean into the spin: pinch in the direction of motion, stretch the
    // perpendicular. Magnitudes are deltas added to the rest scale (1).
    this.squashX += direction * 0.18;
    this.squashY -= 0.22;
  }

  reset(): void {
    this.squashX = 0;
    this.squashY = 0;
    this.breath = 0;
    this.player.mesh.scale.set(1, 1, 1);
  }

  update(dt: number, audioLowEnergy: number): void {
    const decay = 1 - Math.exp(-SQUASH_DECAY_LAMBDA * dt);
    this.squashX = THREE.MathUtils.lerp(this.squashX, 0, decay);
    this.squashY = THREE.MathUtils.lerp(this.squashY, 0, decay);
    const targetBreath = audioLowEnergy * BREATH_GAIN;
    this.breath = THREE.MathUtils.lerp(
      this.breath,
      targetBreath,
      1 - Math.exp(-BREATH_LAMBDA * dt)
    );
    const sx = 1 + this.squashX + this.breath;
    const sy = 1 + this.squashY + this.breath;
    const sz = 1 + this.breath;
    this.player.mesh.scale.set(sx, sy, sz);
  }
}
